import styled from 'styled-components';
import Button from '@mui/material/Button';

export const StyledButton = styled(Button)(({ theme }) => ({
  '&&': {
    color: '#063F58',
    fontSize: 14,
    lineHeight: 1.1,
    fontFamily: ['Inter', 'normal'].join(','),
    fontWeight: 700,
    fontStyle: 'bold',
    textTransform: 'none',
    padding: '12px 0 12px 20px',
    transition: '0.2s',
  },
  '&&:hover': {
    backgroundColor: 'transparent',
    transition: '0.2s',
    '& .MuiButton-startIcon': {
      // marginLeft: theme.spacing(4),
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0.5),
    }
  },
  '& .MuiButton-startIcon': {
    // marginLeft: theme.spacing(4),
    transition: '0.2s',
    marginTop: theme.spacing(-0.3),
    paddingLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  }
}));

export const LeftArrowIcon = styled.span({
  '&:before': {
    display: 'block',
    width: 14,
    height: 12,
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='14' height='12' viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.2 3L1 7M1 7L5.2 11M1 7H13' stroke='%23063F58' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    content: '""',
  },
});
